import React from 'react';
import { Switch } from 'react-router-dom';

import { PERMISSIONS, ROUTES } from '../../../constants';
import PrivateRoute from '../../../routes/PrivateRoute';
import { MessagesCenter } from '../pages/MessagesCenter';

// Mesma permissão do Painel de Gestão: quem gere a operação conversa
// com os motoristas (permissão própria pode vir depois).
export const ChatRoute: React.FC = () => (
  <Switch>
    <PrivateRoute
      path={ROUTES.messagesCenter}
      permission={PERMISSIONS.DASHBOARD_VIEW}
      component={MessagesCenter}
    />
  </Switch>
);
